export const renderMonthlyBarCharts = (root = document) => {
    const chartCanvases = root.querySelectorAll('[data-bar-chart]');
    if (chartCanvases.length === 0) return;

    const rootStyles = getComputedStyle(document.documentElement);

    function hexToRgba(hex, alpha) {
        const normalizedHex = hex.trim();
        const r = parseInt(normalizedHex.slice(1, 3), 16);
        const g = parseInt(normalizedHex.slice(3, 5), 16);
        const b = parseInt(normalizedHex.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    chartCanvases.forEach((chartCanvas) => {
        const ctx = chartCanvas.getContext('2d');
        const labels = JSON.parse(chartCanvas.dataset.labels);
        const income = JSON.parse(chartCanvas.dataset.income);
        const costs = JSON.parse(chartCanvas.dataset.costs);
        const incomeLabel = chartCanvas.dataset.incomeLabel ?? 'Income';
        const costsLabel = chartCanvas.dataset.costsLabel ?? 'Costs';
        const colorGreen = chartCanvas.dataset.incomeColor ?? rootStyles.getPropertyValue('--color-neutral').trim();
        const colorRed = chartCanvas.dataset.costsColor ?? rootStyles.getPropertyValue('--feel-bad').trim();

        const gradientStrokeIncome = ctx.createLinearGradient(0, 230, 0, 50);
        gradientStrokeIncome.addColorStop(1, hexToRgba(colorGreen, 0.2));
        gradientStrokeIncome.addColorStop(0.4, hexToRgba(colorGreen, 0.0));
        gradientStrokeIncome.addColorStop(0, hexToRgba(colorGreen, 0));

        const gradientStrokeCosts = ctx.createLinearGradient(0, 230, 0, 50);
        gradientStrokeCosts.addColorStop(1, hexToRgba(colorRed, 0.2));
        gradientStrokeCosts.addColorStop(0.4, hexToRgba(colorRed, 0.0));
        gradientStrokeCosts.addColorStop(0, hexToRgba(colorRed, 0));

        new Chart(ctx, {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [
                    {
                        label: incomeLabel,
                        backgroundColor: gradientStrokeIncome,
                        hoverBackgroundColor: gradientStrokeIncome,
                        borderColor: colorGreen,
                        borderWidth: 2,
                        data: Array.isArray(income) ? income : [income]
                    },
                    {
                        label: costsLabel,
                        backgroundColor: gradientStrokeCosts,
                        hoverBackgroundColor: gradientStrokeCosts,
                        borderColor: colorRed,
                        borderWidth: 2,
                        data: Array.isArray(costs) ? costs : [costs]
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    position: 'bottom'
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                }
            }
        });
    });
};

document.addEventListener('DOMContentLoaded', () => renderMonthlyBarCharts());
